interface ICountdown {
  element: Element
  date: string
}

interface ITemplate {
  days: number
  hours: number
  minutes: number
  seconds: number
}

const SECOND_MS = 1000

const getDate = (date: string) => {
  const endDate = new Date(date).toISOString()
  const currDate = new Date().toISOString()

  const total = Date.parse(endDate) - Date.parse(currDate)
  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / 1000 / 60) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))

  return { days, hours, minutes, seconds, total }
}

const getTemplate = ({ days, hours, minutes, seconds }: Partial<ITemplate>) => {

  let newDays = (days && days < 10 || days === 0) ? `0${days}` : days

  let newHours = (hours && hours < 10 || hours === 0) ? `0${hours}` : hours

  let newMinutes = (minutes && minutes < 10 || minutes === 0) ? `0${minutes}` : minutes

  let newSeconds = (seconds && seconds < 10 || seconds === 0) ? `0${seconds}` : seconds


  return `
  <span><strong>${newDays}</strong><span>dni</span></span>
  <span><strong>${newHours}</strong><span>godz.</span></span>
  <span><strong>${newMinutes}</strong><span>min.</span></span>
  <span><strong>${newSeconds}</strong><span>sec.</span></span>
  `
}

const setCountdown = ({ element, date }: ICountdown) => {
  const timeLeft = getDate(date)
  element.innerHTML = getTemplate({
    days: timeLeft.days,
    hours: timeLeft.hours,
    minutes: timeLeft.minutes,
    seconds: timeLeft.seconds,
  })

  const hasEnded = timeLeft.total <= 0

  if (hasEnded) {
    element.innerHTML = '<span class="ended">Koniec czasu!</span>'
  }

  return hasEnded
}

window.addEventListener('load', () => {
  const elements = document.querySelectorAll('[data-countdown]')

  if (elements.length === 0) return

  elements.forEach((el, index) => {
    const date = el.getAttribute('data-countdown-date')

    if (!date) return

    setCountdown({ element: el, date })

    const interval = setInterval(() => {
      const hasEnded = setCountdown({ element: el, date })

      if (hasEnded) {
        clearInterval(interval)
      }
    }, SECOND_MS)
  })
})
